import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';
import Link from 'client/components/aria/Link/Link';
import { ENQUIRIES_PAGE } from 'client/utils/routes/routeConstants';
import Panel from 'client/components/aria/Panel/Panel';

const EnquiryAlertSuccess = ({ enquiryId, ...props }) => {
    const intl = useIntl();

    const messageContent = (
        <div>
            <p className="govuk-!-margin-bottom-2">
                <FormattedMessage
                    id="enquiryAlerts.success"
                    values={{
                        Link: text => <Link href={ENQUIRIES_PAGE}>{text}</Link>
                    }}
                />
            </p>
            {enquiryId
                ? (
                    <p className="govuk-!-font-weight-bold govuk-!-margin-0" data-testid="enquiry-alert-success-id">
                        {enquiryId}
                    </p>
                )
                : null}
        </div>
    );

    return (
        <Panel
            {...props}
            title={intl.formatMessage({ id: 'enquiryAlerts.success.title' })}
            message={messageContent}
        />
    );
};

EnquiryAlertSuccess.propTypes = {
    ...defaultAriaProps,
    enquiryId: PropTypes.string
};

export default EnquiryAlertSuccess;
